import "react-modern-drawer/dist/index.css";

import Ellipses from "./Ellipses";
import PlenumLogoTitle from "../PlenumLogoTitle";
import Links from "./Links";
import Hamburger from "./Hamburger";
import { UserButton } from "@clerk/clerk-react";

export default () => {
    return (
        <div className="flex flex-row items-center justify-between bg-darkblue lg:bg-transparent min-w-full w-full h-fit px-6 sm:px-8 select-none">
            <div>
                {" "}
                {/* this forces justify-between for large breakpoints */}
                <Ellipses />
            </div>

            <div className="lg:hidden">
                <PlenumLogoTitle />
            </div>

            <div className="flex flex-row items-center gap-1 sm:gap-4 py-5">
                <Links />

                <UserButton afterSignOutUrl="/" />

                <Hamburger />
            </div>
        </div>
    );
};
